import { useEffect } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import {
  cleanupAccessTokenCookie,
  clearStorageTokens,
  Log,
  ProfileStorage,
} from "@ryde/shared";

import { isLoggedInLandingAtom, landingActiveStepAtom } from "../atoms";
import { LandingStepEnum } from "../enums";
import { useLandingProfile } from "./use-landing-profile";
import { useLandingsNavigation } from "./use-landings-navigation";

export type UseLandingsAuthModel = Omit<
  ReturnType<typeof useLandingsAuth>,
  "handleLogout"
>;

export const initialLandingsUseAuthModel = {
  isLoggedIn: false,
};

export const useLandingsAuth = () => {
  const { clearProfileRecoilStore } = useLandingProfile();
  const activeStep = useRecoilValue(landingActiveStepAtom);
  const isLoggedIn = useRecoilValue(isLoggedInLandingAtom);
  const { navigateLogin } = useLandingsNavigation();

  const handleLogout = useEvent((): void => {
    Log.debug(`landing Logout handler called`);
    clearProfileRecoilStore();
    clearStorageTokens();
    ProfileStorage.authSet = undefined;
    cleanupAccessTokenCookie();
  });

  useEffect(() => {
    const protectedSteps = [LandingStepEnum.ChooseStationStep];

    if (protectedSteps.includes(activeStep) && !isLoggedIn) {
      Log.debug("User logged out, navigating to login");
      navigateLogin();
    }
  }, [activeStep, isLoggedIn, navigateLogin]);

  return { isLoggedIn, handleLogout };
};
